





















import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { Action, Getter, State } from 'vuex-class';
import { deploymentSvc } from '@/services';
import { Deployment, Credentials } from '@/types';

@Component({
  name: 'upimport-info-dialog',
  components: {}
})
export default class UpimportInfoDialog extends Vue {
  @Prop({ required: true })
  show!: boolean;

  @Prop({ required: true })
  deployment!: Deployment;

  credentials: Credentials | null = null;
  fetchingCredentials: boolean = false;

  async fetchCredentials() {
    this.fetchingCredentials = true;
    try {
      this.credentials = await deploymentSvc.getCredentials(this.deployment.id);
    } catch (e) {
      // blank
    }
    this.fetchingCredentials = false;
  }

  closeDialog() {
    this.$emit('close');
  }
}
